import { Grid, Stack, Switch, Typography, useTheme } from '@mui/material'
import React from 'react'
import { EmailMessageType } from '../../services/api/sharedTypes/Email'
import { convertEmailMessageTypeToString, convertStringToEmailMessageType } from '../../utils/email-utils'
import CustomContainer from '../common/CustomContainer'

interface EmailSwitchesProps {
    emailSwitches: Record<EmailMessageType, boolean>
    onChange: (emailSwitches: Record<EmailMessageType, boolean>) => void
}

const EmailSwitches: React.FC<EmailSwitchesProps> = ({ emailSwitches, onChange }: EmailSwitchesProps) => {
    const theme = useTheme()
    return (
        <CustomContainer bgColor={theme.palette.background.default}>
            <Typography variant='h6' mb={2}>
                Odesílat připomínkové emaily
            </Typography>
            <Grid container columnSpacing={3}>
                {Object.entries(emailSwitches).map(([key, value], index: number) => {
                    if (key === 'NotSet') return null
                    return (
                        <Grid item xs={6} key={index}>
                            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                                <Typography>{convertEmailMessageTypeToString(convertStringToEmailMessageType(key))}</Typography>
                                <Switch
                                    checked={value}
                                    onChange={(event) => {
                                        onChange({ ...emailSwitches, [key]: event.target.checked })
                                    }}
                                />
                            </Stack>
                        </Grid>
                    )
                })}
            </Grid>
        </CustomContainer>
    )
}

export default EmailSwitches
